export var logAppInfo = function logAppInfo(name, version) {
  if (navigator.userAgent.toLowerCase().includes('chrome')) {
    var args = ["%c    Decidata \u2730 %c" + name + ' v' + version + '    ', 'color: #fff; background: linear-gradient(#5961de, #2882de); padding:10px 0; border-bottom-left-radius: 4px; border-top-left-radius: 4px; font-weight:bold;', 'color: #fff; background: linear-gradient(#5961de, #2882de); padding:10px 0; border-bottom-right-radius: 4px; border-top-right-radius: 4px;'];
    window.console.log.apply(console, args);
    return;
  }

  console.log("Decidata \u2730 " + name + ' v' + version);
};